package com.macrofocus.eflux

enum class TableType {
    BUS {
        override fun toString(): String {
            return "Bus"
        }
    },

    BRANCH {
        override fun toString(): String {
            return "Branch"
        }
    },

    CROSSBORDER {
        override fun toString(): String {
            return "Cross-border"
        }
    }
}